import { render, staticRenderFns } from "./PFlow.vue?vue&type=template&id=47bbdd4b&scoped=true"
import script from "./PFlow.vue?vue&type=script&lang=js"
export * from "./PFlow.vue?vue&type=script&lang=js"
import style0 from "./PFlow.vue?vue&type=style&index=0&id=47bbdd4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbdd4b",
  null
  
)

export default component.exports